var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"color":"#868686"}},[_c('el-icon',{staticClass:"el-icon-warning-outline"}),_c('span',[_vm._v(" "+_vm._s(_vm.option))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }